import React from "react";
import { EuiCollapsibleNavGroup, EuiPinnableListGroup } from "@elastic/eui";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { authorizedActionsSelector } from "../../../auth/slice";
import checkAuthorization from "../../../auth/helpers/checkAuthorization";
import isMobile from "../../../../utils/isMobile";
import trackAnalytics from "../../../../trackAnalytics";

export const SideBarContainer = styled.div`
    overflow-y: auto;
    max-height: 425px;
`;
const orderLinks = (authorizedActions, history) => [
    {
        label: <FormattedMessage id="drawer.order.create" />,
        iconType: "visMapRegion",
        onClick: () => {
            trackAnalytics("Admin_home_Create_new_order");
            history.push("/orders/create");
        },
        isDisabled: !checkAuthorization(authorizedActions, "trips"),
    },
    {
        label: <FormattedMessage id="drawer.order.monitor" />,
        iconType: "visMapRegion",
        onClick: () => {
            trackAnalytics("Admin_home__Monitor active orders");
            history.push("/monitoring");
        },
        isDisabled: !checkAuthorization(authorizedActions, "trips"),
    },
];
const databaseLinks = (authorizedActions, history) => [
    {
        label: <FormattedMessage id="layout.orders" />,
        iconType: "visTable",
        onClick: () => {
            trackAnalytics("Admin_home__orders");
            history.push("/database/orders");
        },
        isDisabled: !checkAuthorization(authorizedActions, "orders"),
    },
    {
        label: <FormattedMessage id="layout.trips" />,
        iconType: "timeline",
        href: "",
        onClick: () => {
            trackAnalytics("Admin_home__trips");
            history.push("/database/trips");
        },
        isDisabled: !checkAuthorization(authorizedActions, "trips"),
    },
    {
        label: <FormattedMessage id="layout.liveTracking" />,
        iconType: "visMapCoordinate",
        href: "",
        onClick: () => {
            history.push("/database/liveTracking");
            trackAnalytics("opened_live_location");
        },
        // isDisabled: !checkAuthorization(authorizedActions, "liveTracking"),
    },
    {
        label: <FormattedMessage id="layout.location-categories" />,
        iconType: "visGauge",
        onClick: () => {
            trackAnalytics("Admin_home__location_categories");
            history.push("/database/locationCategories");
        },
        isDisabled: !checkAuthorization(authorizedActions, "locationCategories"),
    },
    {
        label: <FormattedMessage id="layout.drivers" />,
        iconType: "users",
        onClick: () => {
            trackAnalytics("Admin_home__drivers");
            history.push("/database/drivers");
        },
        isDisabled: !checkAuthorization(authorizedActions, "drivers"),
    },
    {
        label: <FormattedMessage id="layout.locations" />,
        iconType: "visMapCoordinate",
        onClick: () => {
            trackAnalytics("Admin_home__locations");
            history.push("/database/locations");
        },
        isDisabled: !checkAuthorization(authorizedActions, "locations"),
    },
    {
        label: <FormattedMessage id="layout.trucks" />,
        iconType: "visGauge",
        onClick: () => {
            trackAnalytics("Admin_home__trucks");
            history.push("/database/trucks");
        },
        isDisabled: !checkAuthorization(authorizedActions, "trucks"),
    },
    {
        label: <FormattedMessage id="layout.truck-types" />,
        iconType: "visGauge",
        onClick: () => {
            trackAnalytics("Admin_home__turcks_types");
            history.push("/database/truckTypes");
        },
        isDisabled: !checkAuthorization(authorizedActions, "truckTypes"),
    },
    {
        label: <FormattedMessage id="layout.clients" />,
        iconType: "reporter",
        onClick: () => {
            trackAnalytics("Admin_home__clients");
            history.push("/database/clients");
        },
        isDisabled: !checkAuthorization(authorizedActions, "organizations"),
    },
    // {
    //     label: 'Client Projects',
    //     iconType: 'reporter',
    //     onClick: () => history.push('/database/clientProjects'),
    //     isDisabled: !checkAuthorization(authorizedActions, 'projects'),
    // },
    {
        label: <FormattedMessage id="layout.branches" />,
        iconType: "reporter",
        onClick: () => {
            trackAnalytics("Admin_home__branches");
            history.push("/database/branches");
        },
        isDisabled: !checkAuthorization(authorizedActions, "branches"),
    },
    {
        label: <FormattedMessage id="layout.client-contracts" />,
        iconType: "document",
        onClick: () => history.push("/database/clientContracts"),
        isDisabled: true, // disabled till further notice
        // isDisabled: !checkAuthorization(authorizedActions, 'organizationContracts'),
    },
    {
        label: <FormattedMessage id="layout.suppliers" />,
        iconType: "users",
        onClick: () => {
            trackAnalytics("Admin_home__suppliers");
            history.push("/database/suppliers");
        },
        isDisabled: !checkAuthorization(authorizedActions, "suppliers"),
    },
    {
        label: <FormattedMessage id="layout.supplier-contracts" />,
        iconType: "document",
        onClick: () => {
            trackAnalytics("Admin_home__suppliers_contracts");
            history.push("/database/supplierContracts");
        },
        isDisabled: !checkAuthorization(authorizedActions, "supplierContracts"),
    },
    {
        label: <FormattedMessage id="layout.devices" />,
        iconType: "document",
        onClick: () => {
            trackAnalytics("Admin_home__devices");
            history.push("/database/devices");
        },
        isDisabled: !checkAuthorization(authorizedActions, "devices"),
    },
    {
        label: <FormattedMessage id="layout.users" />,
        iconType: "user",
        onClick: () => {
            trackAnalytics("Admin_home__users");
            history.push("/database/users");
        },
        isDisabled: !checkAuthorization(authorizedActions, "users"),
    },
    {
        label: <FormattedMessage id="layout.projects" />,
        iconType: "document",
        onClick: () => {
            trackAnalytics("Admin_home__projects");
            history.push("/database/projects");
        },
        isDisabled: !checkAuthorization(authorizedActions, "projects"),
    },
    // TODO: change to "supplier_partner_projects"
    {
        label: <FormattedMessage id="layout.sp-projects" />,
        iconType: "document",
        onClick: () => {
            trackAnalytics("Admin_supplier_partner_projects");
            history.push("/database/sp-projects");
        },
        isDisabled: !checkAuthorization(authorizedActions, "projects"),
    },
    {
        label: <FormattedMessage id="layout.admins" />,
        iconType: "user",
        onClick: () => {
            trackAnalytics("Admin_home__admins");
            history.push("/database/admins");
        },
        isDisabled: !checkAuthorization(authorizedActions, "adminUsers"),
    },
    {
        label: <FormattedMessage id="layout.organization-assignees" />,
        iconType: "user",
        onClick: () => {
            trackAnalytics("Admin_home__organization_assignees");
            history.push("/database/organizationAssignees");
        },
        isDisabled: !checkAuthorization(authorizedActions, "organizationAssignees"),
    },
    {
        label: <FormattedMessage id="layout.tags" />,
        iconType: "user",
        onClick: () => {
            trackAnalytics("Admin_home__tags");
            history.push("/database/tags");
        },
        isDisabled: !checkAuthorization(authorizedActions, "tags"),
    },
];

function Drawer() {
    const authorizedActions = useSelector(authorizedActionsSelector());
    const history = useHistory();
    return (
        <div>
            <EuiCollapsibleNavGroup
                iconType="documents"
                iconProps={{ color: "#16839e" }}
                isCollapsible
                initialIsOpen={!isMobile()}
                title={<FormattedMessage id="drawer.order.title" />}
            >
                <EuiPinnableListGroup
                    gutterSize="none"
                    color="text"
                    size="s"
                    listItems={orderLinks(authorizedActions, history)}
                />
            </EuiCollapsibleNavGroup>

            <EuiCollapsibleNavGroup
                iconType="database"
                iconProps={{ color: "#16839e" }}
                isCollapsible
                initialIsOpen={!isMobile()}
                title={<FormattedMessage id="drawer.database.title" />}
            >
                <SideBarContainer>
                    <EuiPinnableListGroup
                        gutterSize="none"
                        color="text"
                        size="s"
                        listItems={databaseLinks(authorizedActions, history)}
                    />
                </SideBarContainer>
            </EuiCollapsibleNavGroup>
        </div>
    );
}

export default Drawer;
